import DrawerHeader from './drawer-header';
import CartItem from './cart-item';
import Recommendations from './recommendations';
import Totals from './totals';
import Footer from './footer';
import FreeDeliveryProgress from '../FreeDeliveryProgress';
import useRelatedProducts from '@/hooks/product/useRelatedProducts';
import { useLocale } from 'next-intl';

const DrawerPanel = ({
  togglePanel,
  t,
  cartItems,
  togglePopup,
  toggleDrawer,
  isLoading,
  relatedProducts,
  totalSegments,
}) => {
  const locale = useLocale();
  const { isLoading: isRelatedProductsLoading } = useRelatedProducts(
    cartItems[cartItems?.length - 1]?.sku ||
      cartItems[cartItems?.length - 1]?.extension_attributes?.product_sku,
    locale
  );

  return (
    <div className='me-0 flex max-h-[min(66vh,640px)] flex-col overflow-hidden rounded-2xl border border-[#e2e8f0] bg-white shadow-[0_12px_40px_rgba(2,6,23,0.15)] md:w-[min(420px,96vw)]'>
      <DrawerHeader toggleDrawer={toggleDrawer} t={t} />
      <div className='flex flex-1 flex-col gap-3 overflow-auto p-[12px_14px]'>
        <FreeDeliveryProgress fixed={false} />

        {cartItems.map((item) => (
          <CartItem key={item.item_id} item={item} t={t} />
        ))}
        {(!!relatedProducts?.length || isRelatedProductsLoading) && (
          <Recommendations
            items={relatedProducts}
            t={t}
            isRelatedProductsLoading={isRelatedProductsLoading}
          />
        )}
      </div>
      <Totals t={t} isLoading={isLoading} totalSegments={totalSegments} />
      <Footer
        togglePanel={togglePanel}
        t={t}
        toggleDrawer={toggleDrawer}
        togglePopup={togglePopup}
      />
    </div>
  );
};

export default DrawerPanel;
